import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Chip from '@mui/material/Chip';

export interface ILayerTreeItemChip {
  countVisible?: number
  countTotal?: number
}

const LayerTreeItemChip: FunctionComponent<ILayerTreeItemChip> = (props) => {
  const { t } = useTranslation();

  const { countVisible, countTotal } = props;

  const hasAllHidden = countVisible === 0;


  const label = `${countVisible} ${t('common.od')} ${countTotal}`;

  return <Chip size="small" label={label} color={hasAllHidden ? 'default' : 'primary'} />;
};

export default LayerTreeItemChip;
